import { getApp, getApps, initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCoEeV14D1BnBugMW4WLd3V_xrFHFhQ1nw',
  authDomain: 'srt-translator-7b113.firebaseapp.com',
  projectId: 'srt-translator-7b113',
  storageBucket: 'srt-translator-7b113.firebasestorage.app',
  messagingSenderId: '562545472761',
  appId: '1:562545472761:web:81cb9ca190c63041e6de28',
  measurementId: 'G-JEVH078TYK',
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

const analyticsPromise =
  typeof window !== 'undefined'
    ? isSupported()
        .then((supported) => (supported ? getAnalytics(app) : null))
        .catch(() => null)
    : Promise.resolve(null);

export const logAnalyticsEvent = (eventName, params) =>
  analyticsPromise.then((analytics) => {
    if (analytics) {
      logEvent(analytics, eventName, params);
    }
  });

export default app;
